module.exports = {
    defaultKeycodes     : require('./lib/default_keycodes'),
    Dispatcher          : require('./lib/Dispatcher'),
    Hotkey              : require('./lib/Hotkey'),
    Keymap              : require('./lib/Keymap'),
    parseKeyCombo       : require('./lib/parse_key_combo')
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/hotkeys/index.js
// module id = 22
// module chunks = 0